import {
  faCheckCircle,
  faCircleExclamation,
  faCircleX,
  faClock,
  faQuestionCircle,
  faWarning
} from "@fortawesome/pro-solid-svg-icons"
import moment from "moment"

export const attendeeStatus = (status, label) => {
  switch (status) {
    case 0:
      return "Ej påbörjad"
    case 1:
      return "Godkänd"
    case 2:
      return "Ej godkänd"
    case 3:
      return label
    default:
      return "-"
  }
}

export function attendeeStatusColor(status) {
  switch (status) {
    case 0:
      return "primary"
    case 1:
      return "success"
    case 2:
      return "error"
    case 3:
      return "warning"
    default:
      return undefined
  }
}

export function attendeeStatusIcon(status) {
  switch (status) {
    case 0:
      return faQuestionCircle
    case 1:
      return faCheckCircle
    case 2:
      return faCircleX
    case 3:
      return faWarning
    default:
      return undefined
  }
}

export function validTo(lastDateForPassedExam, t) {
  if (lastDateForPassedExam !== null && moment(lastDateForPassedExam).diff(moment(), "days") > 30) {
    return { color: null, label: moment(lastDateForPassedExam).format("YYYY-MM-DD") }
  } else if (moment(lastDateForPassedExam).diff(moment(), "days") > 0) {
    return {
      icon: faClock,
      color: "warning",
      label: `${t("learning.tites.due_in", "Due in")} ${moment(lastDateForPassedExam).diff(
        moment(),
        "days"
      )} ${t("global.days", "days")}`
    }
  } else if (lastDateForPassedExam === null || moment(lastDateForPassedExam).diff(moment(), "days") < 0) {
    return {
      icon: faCircleExclamation,
      color: "error",
      label:
        lastDateForPassedExam === null
          ? `${t("learning.titles.expired", "Expired")}`
          : `${t("learning.titles.overdue_for", "Overdue for")} ${moment(lastDateForPassedExam)
              .diff(moment(), "days")
              .toString()
              .replace("-", "")} ${t("global.days_ago", "days ago")}`
    }
  }

  return null
}

export function getExaminationNameTranslation(examinationName, t) {
  switch (examinationName) {
    case "Kör- & vilotider":
      return t("learning.admin.overview.driving_rest_passenger_traffic", "Driving & rest times")
    case "Kör- & vilotider (Godstrafik)":
      return t(
        "learning.admin.overview.driving_rest_freight_traffic",
        "Driving & rest times (Freight traffic)"
      )
    case "Miljöutbildning - Transport":
      return t("learning.admin.overview.environmental", "Environmental education - Transport")
    default:
      return examinationName
  }
}
